import { useWebchat } from 'modules/webchat/presentation/contexts';
import {
  AcceptedPaymentMethods,
  AllRightsFooter,
  AppStoreIcons,
  FooterBottomLinks,
  FooterContact,
  RdStationScript,
  VialaserLogo,
  VialaserSocials,
  WhatsAppFloatingButton,
} from 'shared/presentation/components/atoms';
import { useTheme } from 'shared/presentation/contexts';

import * as S from './styles';

const LOGO_SIZE = 172;

const StoreFooter: React.FC = () => {
  const { theme } = useTheme();
  const webchat = useWebchat();
  // Sem Webchat na tenância, ou com o widget fora do ar nesta carga, o WhatsApp volta.
  const shouldShowWhatsApp = !webchat.isEnabled || webchat.status === 'failed';

  return (
    <>
      <S.Container>
        <div className="info">
          <div>
            <VialaserLogo
              size={LOGO_SIZE}
              color={theme.palette.text.main}
              colors={{ via: theme.palette.primary.main }}
            />
            <FooterBottomLinks />
            <AcceptedPaymentMethods />
          </div>

          <div>
            <AppStoreIcons />
            <FooterContact />
            <VialaserSocials />
          </div>
        </div>

        <AllRightsFooter />
      </S.Container>

      <RdStationScript />
      {shouldShowWhatsApp && <WhatsAppFloatingButton />}
    </>
  );
};

export default StoreFooter;
